import fetchAPI from '../fetchAPI';

export interface AddKeyPayload {
  name: string;
  /** Locations the key should be authorised for. Pass a one-item array for single-location keys. */
  locationIds?: string[];
  expiresAt?: string; // ISO date string for client keys
}

export const callAddKey = async (data: AddKeyPayload): Promise<iResponse<{ data: Keys }>> => {
  const response: iResponse<{ data: Keys }> = await fetchAPI({
    method: `POST`,
    route: `api-key`,
    data
  });

  // const {error} = response;
  // if (error) throw new ResponseError(error);

  return response;
};

export default callAddKey;
